import methods from "./methods";
import apis from "./apis";

export const mixins =  {
    ...methods,
    api:apis
}

export default mixins;